module.exports = __webpack_public_path__ + "img/artboard5.ed54f567.png";